module.exports = __webpack_public_path__ + "static/media/2B.af2a480a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/Files/2B.pdf
// module id = 82
// module chunks = 0